export default (user, { can, cannot, rules }) => {
  if (user.hasRole('yitUser')) {
    can("manage", "emailletters");
    can("manage", "emailletter", {
      projectId: { $in: user.hcExtIds }
    });
  }
}